import { SET_AUTHENTICATION, SET_SELLER } from "./const";

export default {

    [SET_AUTHENTICATION](state, authenticated) {
        state.authenticated = authenticated
    },
    [SET_SELLER](state, seller) {
        state.seller = seller
    },
}